// A component that presents a __title that when clicked reveals/hides the __content below
// Initial use case a question + answer component
// Initial state can be set with questionanswer--is-closed and questionanswer--is-open
// If no initial state is set then questionanswer--is-closed is assumed as default and added

export default function () {
  $(document).ready(function () {
    // close questions marked as closed
    $('.questionanswer--is-closed').find('.questionanswer__content').hide()

    // deal with questionanswers that don't have a state class; deafault these to closed
    $('.questionanswer').each(function () {
      if (!$(this).hasClass('questionanswer--is-closed') && !$(this).hasClass('questionanswer--is-open')) {
        $(this).addClass('questionanswer--is-closed')
        $(this).find('.questionanswer__content').hide()
      }
    })

    // Set up interactivity
    $('.questionanswer').on('click', '.questionanswer__title', function (e) {
      // dont let clicks reach parent elements
      e.stopPropagation()

      // open and close questionanswers
      // Simple toggle logic relies on good HTML structure and starting state
      // if this becomes problematic, replace with verbose if-open-then-close and if-closed-then-open-logic
      $(this).closest('.questionanswer').toggleClass('questionanswer--is-open').toggleClass('questionanswer--is-closed')
      $(this).next('.questionanswer__content').slideToggle('fast')
    })
  })
}
